import React, { useState } from 'react';
import HistorialService from '../services/historiales';
import { notificationSystem } from '../utils/notifications';

function Evoluciones({ evoluciones, paciente_id, onRefresh }) {
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fecha_evaluacion: new Date().toISOString().split('T')[0],
    tipo_evaluacion: 'evaluacion_clinica',
    estado_general: '',
    sintomas_actuales: '',
    avances_logrados: '',
    areas_mejora: '',
    recomendaciones: '',
    proximo_seguimiento: '',
    evaluador: ''
  });

  const tiposEvaluacion = [
    { value: 'evaluacion_clinica', label: 'Evaluación Clínica' },
    { value: 'seguimiento', label: 'Seguimiento' },
    { value: 'evaluacion_final', label: 'Evaluación Final' },
    { value: 'reevaluacion', label: 'Reevaluación' }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await HistorialService.agregarEvolucion(paciente_id, formData);
      notificationSystem.success('Evolución registrada');
      setMostrarFormulario(false);
      setFormData({
        fecha_evaluacion: new Date().toISOString().split('T')[0],
        tipo_evaluacion: 'evaluacion_clinica',
        estado_general: '',
        sintomas_actuales: '',
        avances_logrados: '',
        areas_mejora: '',
        recomendaciones: '',
        proximo_seguimiento: '',
        evaluador: ''
      });
      onRefresh();
    } catch (error) {
      console.error('Error:', error);
      notificationSystem.error('Error al guardar evolución');
    } finally {
      setLoading(false);
    }
  };

  const getEtiquetaTipo = (tipo) => {
    const tipo_map = {
      'evaluacion_clinica': '🔍 Evaluación Clínica',
      'seguimiento': '📊 Seguimiento',
      'evaluacion_final': '✅ Evaluación Final',
      'reevaluacion': '🔄 Reevaluación'
    };
    return tipo_map[tipo] || tipo;
  };

  return (
    <div className="evoluciones-section">
      <button 
        className="btn-agregar" 
        onClick={() => setMostrarFormulario(!mostrarFormulario)}
      >
        + Registrar Evolución
      </button>

      {mostrarFormulario && (
        <form onSubmit={handleSubmit} className="formulario">
          <div className="form-row">
            <div>
              <label>Fecha de Evaluación *</label>
              <input 
                type="date" 
                name="fecha_evaluacion"
                value={formData.fecha_evaluacion}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Tipo de Evaluación *</label>
              <select 
                name="tipo_evaluacion"
                value={formData.tipo_evaluacion}
                onChange={handleChange}
                required
              >
                {tiposEvaluacion.map(tipo => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label>Evaluador</label>
            <input 
              type="text" 
              name="evaluador"
              placeholder="Nombre del evaluador"
              value={formData.evaluador}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Estado General del Paciente *</label>
            <textarea 
              name="estado_general"
              placeholder="Descripción del estado general actual"
              value={formData.estado_general}
              onChange={handleChange}
              rows="3"
              required
            />
          </div>

          <div>
            <label>Síntomas Actuales</label>
            <textarea 
              name="sintomas_actuales"
              placeholder="Síntomas presentes en la evaluación"
              value={formData.sintomas_actuales}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div>
            <label>Avances Logrados *</label>
            <textarea 
              name="avances_logrados"
              placeholder="Progresos y mejoras observadas"
              value={formData.avances_logrados}
              onChange={handleChange}
              rows="3"
              required
            />
          </div>

          <div>
            <label>Áreas de Mejora</label>
            <textarea 
              name="areas_mejora"
              placeholder="Aspectos que aún requieren trabajo"
              value={formData.areas_mejora}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div>
            <label>Recomendaciones</label>
            <textarea 
              name="recomendaciones"
              placeholder="Recomendaciones para el paciente"
              value={formData.recomendaciones}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div>
            <label>Próximo Seguimiento</label>
            <input 
              type="date" 
              name="proximo_seguimiento"
              value={formData.proximo_seguimiento}
              onChange={handleChange}
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="btn-guardar" disabled={loading}>
              {loading ? 'Guardando...' : 'Guardar Evolución'}
            </button>
            <button 
              type="button" 
              className="btn-cancelar" 
              onClick={() => setMostrarFormulario(false)}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      <div className="evoluciones-lista">
        {evoluciones.length === 0 ? (
          <p className="no-data">No hay registros de evolución</p>
        ) : (
          evoluciones.map((evol) => (
            <div key={evol.id} className="evolucion-card">
              <div className="nota-header">
                <div>
                  <h4>{getEtiquetaTipo(evol.tipo_evaluacion)}</h4>
                  <small>{new Date(evol.fecha_evaluacion).toLocaleDateString()}</small>
                </div>
              </div>

              {evol.evaluador && (
                <p><strong>Evaluador:</strong> {evol.evaluador}</p>
              )}

              {evol.estado_general && (
                <div className="info-section">
                  <strong>Estado General:</strong>
                  <p>{evol.estado_general}</p>
                </div>
              )}

              {evol.sintomas_actuales && (
                <div className="info-section">
                  <strong>Síntomas Actuales:</strong>
                  <p>{evol.sintomas_actuales}</p>
                </div>
              )}

              <div className="avances-area">
                <strong>✅ Avances Logrados:</strong>
                <p>{evol.avances_logrados}</p>
              </div>

              {evol.areas_mejora && (
                <div className="info-section">
                  <strong>📌 Áreas de Mejora:</strong>
                  <p>{evol.areas_mejora}</p>
                </div>
              )}

              {evol.recomendaciones && (
                <div className="info-section">
                  <strong>💡 Recomendaciones:</strong>
                  <p>{evol.recomendaciones}</p>
                </div>
              )}

              {evol.proximo_seguimiento && (
                <p className="proximo-seguimiento">
                  <strong>📅 Próximo Seguimiento:</strong> {new Date(evol.proximo_seguimiento).toLocaleDateString()}
                </p>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Evoluciones;
